const STALE_ASSET_RELOAD_KEY = "mixitone:stale-asset-reload";

const STALE_ASSET_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /error loading dynamically imported module/i,
  /Loading chunk [\w-]+ failed/i,
  /Unable to preload CSS/i,
];

export function isStaleAssetError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return STALE_ASSET_PATTERNS.some((pattern) => pattern.test(message));
}

const MAX_RELOAD_ATTEMPTS = 2;

function reloadForFreshAssets(): void {
  const url = new URL(window.location.href);
  url.searchParams.set("_", String(Date.now()));
  window.location.replace(url.toString());
}

/** Reload when a hashed asset from a previous deploy is missing. Returns true if reloading. */
export function tryRecoverStaleAsset(error: unknown): boolean {
  if (typeof window === "undefined" || !isStaleAssetError(error)) {
    return false;
  }

  const attempts = Number(sessionStorage.getItem(STALE_ASSET_RELOAD_KEY) ?? 0);
  if (attempts >= MAX_RELOAD_ATTEMPTS) {
    return false;
  }

  sessionStorage.setItem(STALE_ASSET_RELOAD_KEY, String(attempts + 1));
  reloadForFreshAssets();

  return true;
}

/** Call once at app startup (web builds). Handles Vite preload / dynamic import failures after deploy. */
export function setupStaleAssetRecovery(): void {
  if (typeof window === "undefined") {
    return;
  }

  window.addEventListener("vite:preloadError", (event) => {
    event.preventDefault();
    tryRecoverStaleAsset(new Error("Failed to fetch dynamically imported module"));
  });

  window.addEventListener("unhandledrejection", (event) => {
    if (tryRecoverStaleAsset(event.reason)) {
      event.preventDefault();
    }
  });

  // Allow a future deploy to trigger another auto-reload after this session booted cleanly.
  window.setTimeout(() => {
    sessionStorage.removeItem(STALE_ASSET_RELOAD_KEY);
  }, 10_000);
}
